import React, { useState, useRef } from 'react';

const BeforeAfterSlider = ({ beforeImage, afterImage, title }) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  const handleMove = (clientX) => {
    if (!containerRef.current) return;
    
    const rect = containerRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    const percentage = Math.max(0, Math.min((x / rect.width) * 100, 100));
    
    setSliderPosition(percentage);
  };

  const handleMouseDown = () => setIsDragging(true);
  const handleMouseUp = () => setIsDragging(false);

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    handleMove(e.clientX);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    handleMove(e.touches[0].clientX);
  };

  return (
    <div className="space-y-4">
      <div
        ref={containerRef}
        className="relative w-full overflow-hidden cursor-ew-resize select-none border border-black/10 group"
        style={{ paddingBottom: '75%' }}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleMouseUp}
      >
        {/* After Image (Background) */}
        <div className="absolute inset-0">
          <img
            src={afterImage}
            alt="After"
            className="w-full h-full object-cover"
            draggable={false}
          />
          <div className="absolute top-6 right-6 px-4 py-2 bg-white border border-black/20 backdrop-blur-sm">
            <span className="text-xs tracking-[0.2em] uppercase font-light">After</span>
          </div>
        </div>

        {/* Before Image (Foreground with clip) */}
        <div
          className="absolute inset-0 transition-none"
          style={{
            clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`
          }}
        >
          <img
            src={beforeImage}
            alt="Before"
            className="w-full h-full object-cover"
            draggable={false}
          />
          <div className="absolute top-6 left-6 px-4 py-2 bg-white border border-black/20 backdrop-blur-sm">
            <span className="text-xs tracking-[0.2em] uppercase font-light">Before</span>
          </div>
        </div>

        {/* Slider Handle */}
        <div
          className="absolute top-0 bottom-0 w-1 bg-white cursor-ew-resize z-30 transition-opacity"
          style={{
            left: `${sliderPosition}%`,
            boxShadow: '0 0 20px rgba(0,0,0,0.3)'
          }}
          onMouseDown={handleMouseDown}
          onTouchStart={handleMouseDown}
        >
          {/* Handle circle */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white border-2 border-black/20 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
            <div className="flex gap-1">
              <div className="w-0.5 h-4 bg-black/40" />
              <div className="w-0.5 h-4 bg-black/40" />
            </div>
          </div>
        </div>
      </div>

      {/* Title */}
      {title && (
        <div className="text-center">
          <p className="text-sm tracking-[0.2em] uppercase text-black/50 font-light">
            {title}
          </p>
        </div>
      )}
    </div>
  );
};

export default BeforeAfterSlider;